import { render, staticRenderFns } from "./Isi.vue?vue&type=template&id=27300500&scoped=true&"
import script from "./Isi.vue?vue&type=script&lang=ts&"
export * from "./Isi.vue?vue&type=script&lang=ts&"
import style0 from "./Isi.vue?vue&type=style&index=0&id=27300500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27300500",
  null
  
)

export default component.exports